class NumberUtils {
  static formatScore = (score: number) => {
    if (score === undefined) score = 0;
    if (score % 1 === 0) {
      return score?.toFixed(0);
    } else {
      return score?.toLocaleString('de-DE', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    }
  };
}

export default NumberUtils;
